import settings from 'settings'

const { apiBaseUrl } = settings

export const SQL_API = `${apiBaseUrl}/v3/sql`
